import {
  getStrategyTagByBusiness,
  fetchTabAuth,
  fetchCityByPoi,
  fetchBizoppAreaTree,
  fetchAreaTree,
  fetchStoreList,
  fetchAreaStoreList,
} from '@/api'
export default {
  // 获取tab全选
  geTabAuth({ commit, state }, params) {
    return fetchTabAuth().then(res => {
      return res.data.tabList
    })
  },
  // 首次进入列表页根据经纬度获取默认城市
  getCityByPoi({ commit, state }, params, cityData) {
    return fetchCityByPoi(params).then(res => {
      commit('updateCityIdWithAuth', res.data)

      commit('updateCommonCityChecked', {
        value: res.data.cityId,
      })
      return res.data
    })
  },
  // new获取通用三个tab的商圈数据
  getCommonAreaTree({ commit, state }, params) {
    return fetchBizoppAreaTree().then(res => {
      if (res) {
        commit('updateCommonCityAreaTree', res.data.areaTree)
      }
    })
  },
  // new获取tab商圈数据
  getAreaTreeByArea({ commit, state }, params) {
    return fetchAreaTree().then(res => {
      if (res) {
        commit('updateCityAreaTree', res.data.areaTree)
      }
    })
  },
  // 获取通用三个tab的列表数据
  getCommonShopList({ commit, state }, params) {
    const { currentTab, pageNo, reset } = params
    delete params.currentTab
    delete params.reset
    if (currentTab === 'areaStore') {
      return fetchAreaStoreList(params).then(res => {
        if (res) {
          commit('updateCommonList', {
            currentTab,
            data: res.data,
            pageNo,
            reset,
          })
        }
      })
    }
    return fetchStoreList(params).then(res => {
      if (res) {
        commit('updateCommonList', {
          currentTab,
          data: res.data,
          pageNo,
        })
      }
    })
  },
  // 获取业务策略数据放到filter筛选项里
  getStrategyTag({ commit, state }, params) {
    return getStrategyTagByBusiness(params).then(res => {
      if (res && res.data && res.data.strategyTag) {
        commit('updateStrategyTag', res.data.strategyTag)
        return res.data.strategyTag
      }
    })
  },
}
